import { createApp } from 'vue'
import App from './App.vue'
import router from './router/router'
import '@/assets/common/css/common.css'
import loading from '@/components/loading/loading.js'
import myAlert from '@/components/alert/alert.js'
import VueWechatTitle from 'vue-wechat-title'
import util from '@/utils/util.js'
import 'vant/lib/index.css'
import com from '@/core/common.js'
// import VConsole from 'vconsole'
// new VConsole()
// router.beforeEach((to, from, next) => {
//   if (
//     !util.isWeChat() &&
//     to.name !== 'blank'
//   ) {
//     next({ name: 'blank', params: { flag: 1 } })
//   }
// })
router.afterEach(() => {
  loading.hide()
  myAlert.close()
})
const app = createApp(App)
app.use(router).use(VueWechatTitle).use(loading).use(util).use(myAlert).use(com)
app.mount('#app')